import React from 'react';
import { Modal } from './Modal';
import { FileText } from 'lucide-react';
interface ContentModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export function ContentModal({
  isOpen,
  onClose,
  title,
  content
}: ContentModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} className="max-w-2xl" data-id="element-70">
      <div className="p-8 md:p-10" data-id="element-71">
        <div className="flex items-center gap-2 mb-2 text-gold-400/70 text-[10px] font-mono tracking-[0.3em] uppercase" data-id="element-72">
          <FileText className="w-3 h-3" data-id="element-73" />
          Legal & Compliance
        </div>

        <h2 className="text-2xl font-bold text-white tracking-tight mb-8 pb-4 border-b border-slate-800" data-id="element-74">
          {title}
        </h2>

        <div className="prose prose-invert prose-slate max-w-none text-slate-400 text-sm leading-relaxed space-y-4" data-id="element-75">
          {content}
        </div>
      </div>
    </Modal>;
}